import React from 'react'
import {VideoOrImageType} from '@local/types'
import {VideoLoop, VideoLoopProps, SanityImage, SanityImageProps} from '@local/ui/components'
import {cx} from '@local/utils/cx'

export type VideoOrImageProps = React.HTMLAttributes<HTMLElement> & VideoOrImageType & {
	videoProps?: Partial<VideoLoopProps>,
	imageProps?: Partial<SanityImageProps>,
	imagePropsMobile?: Partial<SanityImageProps>,
	desktopWidth?: number,
	mobileWidth?: number,
	width?: number,
	height?: number,
	ratioMobile?: number,
	priority?: boolean,
	desktopOnly?: boolean,
	fill?: boolean,
}

export const VideoOrImage = ({
	className,
	selectedTab = 'image',
	video,
	videoProps = {},
	image,
	imageProps = {},
	imagePropsMobile,
	desktopOnly,
	desktopWidth,
	mobileWidth,
	width,
	height,
	ratioMobile,
	priority,
	fill,
}: VideoOrImageProps) => {
	if (selectedTab === 'video' && video?.srcs?.length) {
		const {poster, ...rest} = video
		return (
			<VideoLoop
				posterDesktopWidth={desktopWidth}
				posterMobileWidth={mobileWidth}
				poster={poster}
				ratio={width && height && width / height}
				fill={fill}
				{...rest}
				{...videoProps}
				priority={priority}
				desktopOnly={desktopOnly}
				className={cx(className, videoProps.className)} />
		)
	} else if (selectedTab === 'image' && image) {
		return (
			<>
				<SanityImage
					image={image}
					desktopWidth={desktopWidth}
					mobileWidth={mobileWidth}
					width={width}
					height={height}
					fill={fill}
					{...imageProps}
					className={cx(className, imageProps.className)}
					priority={priority}
					desktopOnly={desktopOnly || !!ratioMobile} />
				{ratioMobile && <SanityImage
					image={image}
					mobileWidth={mobileWidth}
					width={width}
					height={width ? (width / ratioMobile | 0) : height}
					fill={fill}
					{...(imagePropsMobile || imageProps)}
					className={cx(className, (imagePropsMobile || imageProps).className)}
					priority={priority}
					desktopOnly={desktopOnly}
					mobileOnly />}
			</>
		)
	}
	return null
}
